import React from 'react';
import ComparisonPage from './ComparisonPage';

export default function VsTeamUnify() {
    return <ComparisonPage slug="teamunify" />;
}
